import { useState } from 'react'
import { Download } from 'lucide-react'
import { useToast } from './primitives.js'
import { telechargerFichier } from './telechargement.js'

/**
 * « EXPORTER CSV » (24/10/2026) — le bouton commun de la fiche soirée et de
 * la fiche de nuit.
 *
 * Le fichier est fabriqué par le serveur, sous les droits de la page ; le
 * bouton ne fait que le télécharger (`telechargerFichier`). Aucune
 * confirmation : c'est une lecture, comme l'export de l'historique des
 * portes. Pendant l'export, le bouton dit « Export… » et ne se relance pas.
 */
export function BoutonExportCsv(props: {
  /** La route GET qui fabrique le fichier. */
  url: string
  /** Le nom du fichier si l'en-tête du serveur n'en donne pas. */
  secours: string
  /** Ce que le fichier contient, en une phrase. */
  title: string
  disabled?: boolean
  /** `ghost` dans les gestes d'un bandeau (fiche de nuit). */
  variante?: 'ghost'
}) {
  const toast = useToast()
  const [enCours, setEnCours] = useState(false)
  const exporter = async () => {
    if (enCours) return
    setEnCours(true)
    try {
      await telechargerFichier(props.url, props.secours, toast)
    } finally {
      setEnCours(false)
    }
  }
  return (
    <button type="button" className={props.variante === 'ghost' ? 'lc-btn lc-btn--ghost' : 'lc-btn'}
      onClick={() => void exporter()} disabled={props.disabled === true || enCours} title={props.title} aria-busy={enCours}>
      <Download size={props.variante === 'ghost' ? 16 : 14} aria-hidden="true" /> {enCours ? 'Export…' : 'Exporter CSV'}
    </button>
  )
}
